'use client';

export const dynamic = 'force-dynamic';

import { Pill } from "@/ui/controls/buttons";
import { HeartIcon, ListBulletIcon, WrenchScrewdriverIcon } from '@heroicons/react/24/outline';
import { usePathname, useSearchParams } from 'next/navigation';
import { urls } from '@/common/urls';
import { FlexRow } from "@/ui/controls/layout";

export function NavLinks() {
  const searchParams = useSearchParams();
  const ts = searchParams.get('ts') || "NOW";
  const URLS = urls({ ts });

  const links = [
    { name: 'Health',  href: URLS.healthCheck.default(),    icon: HeartIcon             },
    { name: 'Tools',   href: URLS.developerTools.default(), icon: WrenchScrewdriverIcon },
    { name: 'Sitemap', href: URLS.sitemap(),                icon: ListBulletIcon        },
  ];

  return <>
    <div className="flex-none rounded-md text-sm font-medium pb-2">
      Resources
      <div className="flex flex-wrap rounded-md text-lg font-medium pb-2">
        {links.map(_ => <NavLink key={_.name} link={_} />)}
      </div>
    </div>
    </>
}

function NavLink({ link }: {
  link: { name: string; href: string; icon: React.ComponentType<React.SVGProps<SVGSVGElement>>; }
}) {
  const pathname = usePathname();

  const isActive = (href: string) => {
    const pathBase = pathname.split('?')[0];
    const hrefBase = href.split('?')[0];
    return pathBase === hrefBase;
  }

  const LinkIcon = link.icon;

  return <>
    <div className="w-1/3 px-1 mb-2">
      <Pill selected={isActive(link.href)} url={link.href}>
        <FlexRow className="items-center gap-2 justify-center">
          <LinkIcon className="w-5" />
          <p className="hidden md:block">{link.name}</p>
        </FlexRow>
      </Pill>
    </div>
  </>;
}
